module.exports = __webpack_public_path__ + "media/images/lineup__iconMarkPickedOption-6ba739d84fc67eb451d5449e3291d4df.png";